<template>
  <div class="w-full h-full flex flex-col">
    <Header />

    <div class="w-full flex-1-0-auto flex flex-col">
      <a id="focusResetAnchor" tabindex="-1" class="hidden" />
      <RouterView :key="$route.fullPath" />
    </div>

    <LostConnectionPopup />
    <SessionPopup />

    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

import Header from '~app/psp/austrian/header.vue'
import Footer from '~app/psp/austrian/footer.vue'
import LostConnectionPopup from '~app/psp/austrian/lost-connection-popup.vue'
import SessionPopup from '~app/psp/austrian/session-popup.vue'

export default Vue.extend({
  components: {
    Header,
    Footer,
    LostConnectionPopup,
    SessionPopup,
  },
})
</script>
